import Vue from 'vue'
import {
  Toast
} from 'mint-ui'

Vue.prototype.$toast = Toast;